import React from 'react';
import RiskReviews from '../../../../../../../../../common/riskReviews';
import { DialogActions } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';

const Evaluations = (props: any) => {
    const {
        selectedRequest,
        setOpenShoppingCart,
    } = props;
    const ImportedModuleLayout = (props: any) => {
        return (
            <div>
                {props.children}
                <DialogActions>
                    <CustomButton
                        onClick={() => setOpenShoppingCart(false)}
                        color="secondary"
                        style={{ marginTop: '10px' }}
                    >
                        {' '}
                        Salir{' '}
                    </CustomButton>
                </DialogActions>
            </div>
        );
    };
    return (
        <ImportedModuleLayout>
            <RiskReviews
                selectedRequest={selectedRequest}
                requestType="factoring-request"
            />
        </ImportedModuleLayout>
    );
};

export default Evaluations;